import { createI18n } from 'vue-i18n'
/*
 * All i18n resources specified in the plugin `include` option can be loaded
 * at once using the import syntax
 */
import messages from '@intlify/unplugin-vue-i18n/messages'

const options = {
	locale: 'en',
	fallbackLocale: {
		/* Here we can set up a map of fallback locales, so Norwegian fallback locale could for example be Swedish (not suggested)  */
		'default': ['en', 'is']
	},
	messages: messages,
	globalInjection: true,
	runtimeOnly: false,
	legacy: false
}

export default createI18n(options)